<template>
	<div
		:class="className"
		@mouseenter.stop.prevent="handleMouseover"
		@mouseleave.stop.prevent="handleMouseout"
	>
		<slot />
	</div>
</template>

<script>
const directions = { 0: 'top', 1: 'right', 2: 'bottom', 3: 'left' };

export default {
	data() {
		return {
			prefix: null,
			direction: null,
		};
	},
	computed: {
		className() {
			return this.prefix ? `${ this.prefix }-${ this.direction }` : '';
		},
	},
	methods: {
		getDirectionKey( ev ) {
			const { width, height, top, left } = this.$el.parentNode.getBoundingClientRect();

			const l = ev.pageX - ( left + window.pageXOffset );
			const t = ev.pageY - ( top + window.pageYOffset );

			const x = l > ( width / 2 ) ? width - l : l;
			const y = t > ( height / 2 ) ? height - t : t;

			if ( x < y ) {
				return x === l ? 3 : 1;
			}

			return y === t ? 0 : 2;
		},
		handleMouseover( evt ) {
			this.prefix = 'in';
			this.direction = directions[ this.getDirectionKey( evt ) ];
		},
		handleMouseout( evt ) {
			this.prefix = 'out';
			this.direction = directions[ this.getDirectionKey( evt ) ];
		},
	},
};
</script>
